export default "__VITE_ASSET__B2nMDde7__"